import * as React from "react";
import { View } from "react-native";

export function useAnimatedTranslateY() {
  const [translateY, setTranslateY] = React.useState(0);

  const style = React.useMemo(
    () => ({
      transform: [{ translateY }],
      transition: "transform 150ms ease",
    }),
    [translateY]
  );

  return { setTarget: setTranslateY, style };
}

export const AnimatedView = View;
